module.exports = __webpack_public_path__ + "img/volume-mute-fill.8e927aaf.svg";